import React, {useEffect, useMemo} from 'react'
import {useGetAdaptiveStyle} from 'uikit'
import {useAppSelector, useAppDispatch} from 'store'
import {YandexService} from 'services/yandexSDK'
import {config} from 'src/config'
import {isOpenWord, getCountOfError, isStart} from 'store/secretword/selectors'
import {startNewGame} from 'store/secretword/slice'
import {showModal} from 'store/modal/slice'
import {getIsFullProgress, getShowCongratulateModal} from 'store/game/selectors'
import {setCongratuateModalWasShown} from 'store/game/slice'
import {addAnsweredIdThunk} from 'store/game/thunk'
import {hideModalThunk} from 'store/modal/thunk'
import {adaptiveConfigMarginTop} from './consts'
import {AttemptsCount} from './AttemptsCount/AttemptsCount'
import LettersBox from './LettersBox'
import {WordBox} from './WordBox'
import Gallow from './Gallow'
import {ProgressBarGame} from './ProgressBarGame'
import styles from './gamepage.scss'

export const GamePage = () => {
  const dispatch = useAppDispatch()
  const isOpenWordFlag = useAppSelector(isOpenWord)
  const countOfError = useAppSelector(getCountOfError)
  const isStartPage = useAppSelector(isStart)
  const isFullProgress = useAppSelector(getIsFullProgress)
  const showCongratulateModal = useAppSelector(getShowCongratulateModal)
  const {isTooSmallScreen, style, styleHideWhenTooSmallScreen} = useGetAdaptiveStyle([
    adaptiveConfigMarginTop,
  ])

  useEffect(() => {
    if (isOpenWordFlag) {
      dispatch(showModal({
        type: 'Win',
        props: {},
      }))
      dispatch(addAnsweredIdThunk())
      YandexService.endGame()
    }
  },[isOpenWordFlag])

  useEffect(() => {
    if (countOfError > config.countGuessAttempts) {
      dispatch(showModal({
        type: 'Lose',
        props: {},
      }))
      YandexService.endGame()
    }
  },[countOfError])

  useEffect(() => {
    if (isFullProgress && !showCongratulateModal) {
      setTimeout(() => {
        dispatch(setCongratuateModalWasShown())
        dispatch(hideModalThunk(async () => {
          if (isOpenWordFlag) {
            dispatch(startNewGame())
          }
          dispatch(showModal({
            type: 'Congratulate',
            props: {},
          }))
        }))
      }, 2500)
    }
  }, [isFullProgress, showCongratulateModal])

  const LettersBoxMemo = useMemo(() => <LettersBox />, [])
  const isShowProgressBar = !isStartPage

  return (
    <div className={styles.gamearea} style={style}>
      <div className={styles.riddlearea}>
        <div className={styles.isMobileWrapper}>
          {isShowProgressBar && <ProgressBarGame />}
        </div>
        {isTooSmallScreen ? <AttemptsCount /> : <Gallow />}
        <WordBox />
      </div>
      <div className={styles.isDesktopWrapper} style={styleHideWhenTooSmallScreen}>
        {isShowProgressBar && <ProgressBarGame />}
      </div>
      {LettersBoxMemo}
    </div>
  )
}
